// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const BytePrefix = {
  Undefined: "00",
  Null: "01",
  False: "02",
  True: "03",
  MinNumber: "04",
  Number: "05",
  MaxNumber: "06",
  MinString: "07",
  String: "08",
  MaxString: "09",
  Int64: "0a",
  Int32: "0b",
  Int16: "0c",
  Int8: "0d",
  Uint64: "0e",
  Uint32: "0f",
  Uint16: "10",
  Uint8: "11",
  Binary: "12",
  Guid: "13",
  Float: "14",
  Infinity: "FF",
};
